import useMediaQuery from "@/hooks/use-media-query.ts";

export default function useIsDesktop() {
    return useMediaQuery("(width >= 1200px)");
}
